import { Button, ModalBody, ModalFooter, Stack } from "@chakra-ui/react";
import { toast } from "react-toastify";
import { fetchController } from "../../../utils/FetchController/fetchController";
import { getHostDomain } from "../../../utils/utils";
import { useEffect } from "react";
import SmartHandoff from "../SmartHandoff";

export default function ConvoToolModal({ onClose, toolUserForm }) {
  const baseUrl = getHostDomain();
  const {
    watch,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
  } = toolUserForm;

  const requiredDropdownFields = [
    "smart_handoff.form_id",
    "smart_handoff.sub_widget_id",
  ];
  const requiredMsg = {
    "smart_handoff.form_id": "Form is required",
    "smart_handoff.sub_widget_id": "Handoff widget is required",
  };

  const smartHandoffFormId = watch(
    "credentials.configuration.smart_handoff.form_id"
  );
  const smartHandoffSubWidgetId = watch(
    "credentials.configuration.smart_handoff.sub_widget_id"
  );

  const checkRequired = () => {
    requiredDropdownFields?.forEach((reqField) => {
      if (!watch(`credentials.configuration.${reqField}`)) {
        setError(`credentials.configuration.${reqField}`, {
          type: "required",
          message: requiredMsg[`${reqField}`],
        });
      }
    });
  };

  useEffect(() => {
    requiredDropdownFields?.forEach((reqField) => {
      if (watch(`credentials.configuration.${reqField}`)) {
        clearErrors(`credentials.configuration.${reqField}`);
      }
    });
  }, [smartHandoffFormId, smartHandoffSubWidgetId]);

  const onSubmit = async (data) => {
    checkRequired();
    if (Object.keys(errors)?.length) return;
    try {
      await fetchController(
        baseUrl + `/api/v1/tool/${data.tool_user_id}/LinkToolUser`,
        "PUT",
        {
          credentials: data.credentials,
        }
      );
      onClose();
      toast.success("Tool setup done");
    } catch (error) {
      toast.error("Some error occurred");
    }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(e); }}>
      <ModalBody>
        <Stack spacing={2}>
          <SmartHandoff toolUserForm={toolUserForm} />
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="blue" type="button" onClick={handleSubmit(onSubmit)}>
          Finish
        </Button>
      </ModalFooter>
    </form>
  );
}
